import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_INPUT_DISTRIBUTION_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const InputDistributionReport = lazy(() =>
  import('../../../screens/InputDistributionReport')
    .then(module => ({default: module.InputDistributionReport})));

const InputDistributionReportNavigation = [
  {
    path: ROUTE_INPUT_DISTRIBUTION_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <InputDistributionReport />
      </Suspense>
    ),
  },
];

export default InputDistributionReportNavigation;
